import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../../../shared/services/shared.service';
import { Toast } from '../../../../shared/models';

@Component({
  selector: 'app-custom-toaster',
  standalone: false,
  templateUrl: './custom-toaster.component.html',
  styleUrl: './custom-toaster.component.scss'
})
export class CustomToasterComponent implements OnInit {
  public listAlerts:Toast[] = [];

  constructor(
    private sharedService:SharedService
  ){}

  ngOnInit(): void {
    this.sharedService.eventCreateToaster.subscribe(
      response => {
        this.listAlerts.push(response);
      }
    )
  }

  public removeAlert(index:number) {
    this.listAlerts.splice(index, 1);
  }

}
